<template>
<!-- COLOQUEI O TREE SEPARADO DO ROUTERVIEW PARA ABRIR EM OUTROS LUGARES Q PRECISA SELECIONAR -->
  <v-card style="border-radius:12px">
    <v-card-title primary-title>
      <div>
        <h4 class="headline mb-0">Departamentos</h4>
      </div>
    </v-card-title>
    <v-card-text>
      <div>
        <v-treeview
          :active.sync="active"
          :open.sync="open"
          rounded
          hoverable
          activatable
          :items="items"
        >
          <template slot="append" slot-scope="{ item }">
            <v-btn v-if="item == active[0]" icon @click="addChild(item)">
              <v-icon  dark>mdi-plus-circle</v-icon>
            </v-btn>
            <v-btn v-if="item == active[0]" icon @click="deleteChild(item)">
              <!-- DELETAR SOMENTE SE NAO HOUVER REGISTERS (FORMS OU EMPLOYEES DENTRO DO SELECIONADO OU DOS FILHOS)-->
              <v-icon dark>mdi-delete-circle</v-icon>
            </v-btn>
          </template>
          <template v-slot:label="{ item, active }">
            <span >{{item.name}}</span>
          </template>
        </v-treeview>
      </div>
    </v-card-text>
  </v-card>
  
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      active: [],
      open: [],
      items: [
        {
          id: 1,
          name: 'Applications :',
          children: [
            { id: 2, name: 'Calendar : app' },
            { id: 3, name: 'Chrome : app' },
            { id: 4, name: 'Webstorm : app' },
          ],
        },
        {
          id: 5,
          name: 'Documents :',
          children: [
            {
              id: 6,
              name: 'vuetify :',
              children: [
                {
                  id: 7,
                  name: 'src :',
                  children: [
                    { id: 8, name: 'index : ts' },
                    { id: 9, name: 'bootstrap : ts' },
                  ],
                },
              ],
            },
            {
              id: 10,
              name: 'material2 :',
              children: [
                {
                  id: 11,
                  name: 'src :',
                  children: [
                    { id: 12, name: 'v-btn : ts' },
                    { id: 13, name: 'v-card : ts' },
                    { id: 14, name: 'v-window : ts' },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 15,
          name: 'Downloads :',
          children: [
            { id: 16, name: 'October : pdf' },
            { id: 17, name: 'November : pdf' },
            { id: 18, name: 'Tutorial : html' },
          ],
        },
        {
          id: 19,
          name: 'Videos :',
          children: [
            {
              id: 20,
              name: 'Tutorials :',
              children: [
                { id: 21, name: 'Basic layouts : mp4' },
                { id: 22, name: 'Advanced techniques : mp4' },
                { id: 23, name: 'All about app : dir' },
              ],
            },
            { id: 24, name: 'Intro : mov' },
            { id: 25, name: 'Conference introduction : avi' },
          ],
        },
      ],
    }    
  },
  methods: {
    getSelected(){
      // SELECTED OBJ É active[0]
      //parece fazer o msm que o watcher
      
    },
    addChild(item){

    },
    deleteChild(item){

    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    selected () {
      if (!this.active.length) return undefined

      const id = this.active[0]

      return this.items.find(item => item.id === id)
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    active2(to, from) {
      if (to){
           // auto-comment// console.log(to[0].name);
        //SETAR STATE selected_department


    //     if (this.$router.currentRoute.name == 'MyCompany'){
    //       this.$router.push('register/department_details/'+to[0])
    //     } else{
    //       this.$router.back()
    //       this.$router.push('register/department_details/'+to[0])
    //     }
    //   } 
    //   else if (to == false){
    // }
      }
    },
    active(nv,ov) {
      if (nv.length >0){
        this.can_go=false
        setTimeout(() => {
          this.can_go = true
        }, 1000);
           // auto-comment// console.log({nv});
        if (this.$router.currentRoute.name == 'MyCompany'){
             // auto-comment// console.log('here');
          setTimeout(() => {
            this.$router.push('/company/register/department_details/'+nv[0])
          }, 1200);
        } else{
             // auto-comment// console.log('there');
          setTimeout(() => {
            this.$router.push('/company/register')
            this.$router.push('/company/register/department_details/'+nv[0])
          }, 1200);
        }
      } else{
        this.$router.push('/company/register')
      }
    }
  }
}
</script>

<style scoped>

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>